// extracted by mini-css-extract-plugin
export var contactText = "Footer-module--contactText--dc42c";
export var content = "Footer-module--content--3f814";
export var copyright = "Footer-module--copyright--a2321";
export var ctaButton = "Footer-module--ctaButton--8c279";
export var footer = "Footer-module--footer--624ab";
export var identity = "Footer-module--identity--61374";
export var identityText = "Footer-module--identityText--7cb65";
export var legalLink = "Footer-module--legalLink--a8848";
export var legalLinks = "Footer-module--legalLinks--0045e";
export var link = "Footer-module--link--418e1";
export var logo = "Footer-module--logo--06605";
export var quickLinks = "Footer-module--quickLinks--fc42e";
export var role = "Footer-module--role--766ff";
export var section = "Footer-module--section--098f8";
export var sectionTitle = "Footer-module--sectionTitle--8bc5e";
export var socialIcon = "Footer-module--socialIcon--19a69";
export var socialLink = "Footer-module--socialLink--37799";
export var socialLinks = "Footer-module--socialLinks--f2c18";
export var socialName = "Footer-module--socialName--2928a";
export var stack = "Footer-module--stack--93969";
export var title = "Footer-module--title--4173d";